export function useToastMessages() {
  const toast = useToast();

  // Success toast
  const successToast = (title: string, description: string) => {
    toast.add({
      title,
      description,
      icon: 'i-heroicons-check-solid'
    });
  };

  // Error toast
  const errorToast = (title: string, description: string) => {
    toast.add({
      title,
      description,
      icon: 'i-heroicons-x-mark',
      color: 'error'
    });
  };

  return {
    successToast,
    errorToast
  };
}
